(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    function formatMoney(cents, moneyFormat) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }

      var value = Number(cents);

      if (!Number.isFinite(value)) return '';

      var amount = (value / 100).toFixed(2);

      var parts = amount.split('.');
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var centsPart = parts[1] ? '.' + parts[1] : '';

      var formatted = dollars + centsPart;

      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, formatted)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, dollars)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, dollars.replace(/,/g, '.'));
    }

    function updateSelectedVariant(card) {
      var picker = card.querySelector('[data-pc-variant-picker]');
      var jsonEl = card.querySelector('[data-pc-variants-json]');
      var addBtn = card.querySelector('[data-pc-add-to-cart]');
      if (!picker || !jsonEl || !addBtn) return;

      var moneyFormat = card.dataset.moneyFormat || '${{amount}}';
      var groups = picker.querySelectorAll('.pc-variant-option-group');
      var selectedOptions = [];
      groups.forEach(function (g) {
        var selBtn = g.querySelector('.pc-variant-btn.is-selected');
        selectedOptions.push(selBtn ? selBtn.dataset.optionValue : null);
      });

      var variants = JSON.parse(jsonEl.textContent);
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });

      var textEl = addBtn.querySelector('.pc-add-to-cart-text');
      var priceEl = card.querySelector('[data-pc-price]');
      var comparePriceEl = card.querySelector('[data-pc-compare-price]');
      var badgeEl = card.querySelector('[data-pc-badge]');
      var linkEl = card.querySelector('.pc-link');

      if (match) {
        addBtn.dataset.variantId = match.id;
        if (match.available) {
          addBtn.disabled = false;
          textEl.textContent = 'Add to cart';
        } else {
          addBtn.disabled = true;
          textEl.textContent = 'Sold out';
        }
        if (priceEl) {
          priceEl.textContent =
            typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function'
              ? Shopify.formatMoney(match.price, moneyFormat)
              : formatMoney(match.price, moneyFormat);
        }
        if (comparePriceEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            comparePriceEl.textContent =
              typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function'
                ? Shopify.formatMoney(match.compare_at_price, moneyFormat)
                : formatMoney(match.compare_at_price, moneyFormat);

            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (badgeEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            var discount = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
            badgeEl.textContent = '-' + discount + '%';
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
        if (linkEl && match.url) linkEl.setAttribute('href', match.url);
      } else {
        addBtn.disabled = true;
        textEl.textContent = 'Unavailable';
      }
    }

    function initCard(card) {
      if (card.dataset.pcInit) return;
      card.dataset.pcInit = 'true';

      var qtyInput = card.querySelector('[data-pc-qty-input]');
      var minusBtn = card.querySelector('[data-pc-qty-minus]');
      var plusBtn = card.querySelector('[data-pc-qty-plus]');
      var addBtn = card.querySelector('[data-pc-add-to-cart]');
      var picker = card.querySelector('[data-pc-variant-picker]');

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) qtyInput.value = val - 1;
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = val + 1;
        });
      }

      if (picker) {
        picker.addEventListener('click', function (e) {
          var btn = e.target.closest('.pc-variant-btn');
          if (!btn || btn.classList.contains('is-unavailable')) return;
          var group = btn.closest('.pc-variant-option-group');
          group.querySelectorAll('.pc-variant-btn').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          updateSelectedVariant(card);
        });
      }

      function getDrawerSectionId() {
        var drawerRoot = document.querySelector(
          'cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer], #cart-drawer, .drawer--cart'
        );
        if (!drawerRoot) return null;
        var sectionWrapper = drawerRoot.closest('[id^="shopify-section-"]');
        if (!sectionWrapper) return null;
        return { wrapper: sectionWrapper, id: sectionWrapper.id.replace('shopify-section-', '') };
      }

      function refreshCartDrawer() {
        var section = getDrawerSectionId();
        if (!section) return Promise.resolve(false);

        return fetch('/?section_id=' + section.id)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newWrapper = doc.getElementById('shopify-section-' + section.id) || doc.body;
            section.wrapper.innerHTML = newWrapper.innerHTML;
            return true;
          })
          .catch(function () { return false; });
      }

      function openCartDrawer() {
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        var drawer = document.querySelector(
          'cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer], #cart-drawer, .drawer--cart'
        );
        if (drawer) {
          if (typeof drawer.open === 'function') { drawer.open(); return; }
          if (typeof drawer.show === 'function') { drawer.show(); return; }
          drawer.classList.add('is-open', 'active', 'open', 'drawer--open');
          document.documentElement.classList.add('cart-drawer-open', 'drawer-open');
          return;
        }

        var cartTrigger = document.querySelector(
          '[data-cart-icon-bubble], #cart-icon-bubble, [data-cart-trigger], .header__icon--cart, a[href="/cart"]'
        );
        if (cartTrigger) {
          cartTrigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        }
      }

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var variantId = addBtn.dataset.variantId;
          if (!variantId || addBtn.disabled) return;

          var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

          addBtn.classList.add('is-loading');
          addBtn.disabled = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add to cart failed');
              return res.json();
            })
            .then(function () { return refreshCartDrawer(); })
            .then(function () { openCartDrawer(); })
            .catch(function () { window.location.href = '/cart'; })
            .finally(function () {
              addBtn.classList.remove('is-loading');
              addBtn.disabled = false;
            });
        });
      }
    }

    function initAll() {
      document.querySelectorAll('.pc-card').forEach(initCard);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
